var Caratlas = $.extend(false, BaseModule ,{

    api_route : 'caratlas',
	
	data : {
        module      : 'caratlas',
        page        : 1,
        limit       : 40,
        order_by   	: 'id:desc',
        view        : 'grid',
        with        : '',
        pagination      : true 
    },
    init:function(){
        "use strict";
        var module_name = this.data.module, module = this;
    },
    deep_linking : function(path){
        "use strict";

        var module = this,path_elements = path.split('/');
        if(path_elements.length === 1){
            module.load_list();
        }else if(path_elements.length === 2 && path_elements[1] === 'new'){
            module.actions('new');
        }else if(path_elements.length === 2 && path_elements[1] > 0){
            module.actions('edit',path_elements[1]);
        }else if(path_elements.length === 2 && path_elements[1] === 'vehicles'){
            module.api_route = 'caratlas/vehicles';
            module.data.order_by = 'VehicleID:asc';
            module.load_list();
        }
    },

});

$(document).ready(function(){
    "use strict";
    Caratlas.init();
});
